import {useSelector} from 'react-redux';
import {fullName} from '../utils/fullName';
import {useMemo} from 'react';

export function useUser() {
  const user = useSelector((state) => state.authReducer.userData);
  return useMemo(() => ({
    user: {
      ...user,
      fullName: user.fullName || fullName(user)
    }
  }), [user]);
}
